import Layout from '../components/Layout';
import AboutMeComponent from '../UI-Components/AboutMeComponent/AboutMeComponent';
import ProfileHeader from '../UI-Components/ProfileHeader/ProfileHeader';
import '../css/ProfilePageFirst.css';
import React, { useState, useEffect } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import { useParams } from 'react-router-dom';

const OtherUserProfilePage = () => {
  const [userInfo, setUserInfo] = useState(null);
  const { userId } = useParams();

  useEffect(() => {
    const fetchUserInfo = async () => {
      if (userId) {
        try {
          const userDocRef = doc(db, "UserInformation", userId);
          const userDocSnap = await getDoc(userDocRef);
          
          if (userDocSnap.exists()) {
            setUserInfo(userDocSnap.data());
          }
        } catch (error) {
          console.error("Error fetching user info:", error);
        }
      }
    };

    fetchUserInfo();
  }, [userId]);

  return (
    <div style={{ backgroundColor: '#F6F6F9', minHeight: '100vh' }}>
      <Layout pageTitle="User Profile">
        <div className="rounded-component-header" style={{ marginBottom: '30px' }}>
          <ProfileHeader userInfo={userInfo} isOtherUser={true}>
          </ProfileHeader>
        </div>
        <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <AboutMeComponent userInfo={userInfo}>
          </AboutMeComponent>
        </div>
        {/* todo add later, not needed for now */}
        {/* <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <PhotosComponent>
          </PhotosComponent>
        </div>
        <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <MostLikedComponent>
          </MostLikedComponent>
        </div>
        <div className="rounded-component" style={{ marginBottom: '30px' }}>
          <VideosComponent>
          </VideosComponent>
        </div> */}
      </Layout>
    </div>
  );
};

export default OtherUserProfilePage; 